module.exports = __webpack_public_path__ + "img/03.f6b88d47.png";